// @flow
import { APP_NAMESPACE } from 'shared/constants/application';

// actions
const namespace: string = `${APP_NAMESPACE}/event`;
export const FETCH: string = `${namespace}/FETCH`;
export const SET: string = `${namespace}/SET`;
export const FAIL: string = `${namespace}/FAIL`;
